import React from 'react';
import { Badge } from '@/components/ui';
import { MapPin, Clock, CheckCircle2, LogOut } from 'lucide-react';

interface CheckInBadgeProps {
  type: 'in' | 'out' | 'active';
  time?: string;
  location?: string;
  className?: string;
}

export const CheckInBadge: React.FC<CheckInBadgeProps> = ({
  type,
  time,
  location,
  className = ''
}) => {
  const config = {
    in: {
      color: 'bg-emerald-50 text-emerald-600 border-emerald-100',
      icon: Clock,
      label: 'CHECK-IN',
    },
    out: {
      color: 'bg-slate-50 text-slate-500 border-slate-100',
      icon: LogOut,
      label: 'CHECK-OUT',
    },
    active: {
      color: 'bg-blue-50 text-blue-600 border-blue-100',
      icon: CheckCircle2,
      label: 'ON-DUTY',
    }
  };

  const { color, icon: Icon, label } = config[type];

  return (
    <div className={`flex items-center gap-3 p-3 rounded-2xl border ${color} ${className} transition-all hover:shadow-sm`}>
      <div className="w-8 h-8 rounded-xl bg-white/50 backdrop-blur-sm flex items-center justify-center shadow-sm">
        <Icon className="w-4 h-4" />
      </div>
      <div>
        <div className="text-[9px] font-black  tracking-[0.1em] opacity-70 mb-0.5">{label}</div>
        <div className="flex items-center gap-3">
          <span className="text-sm font-black leading-none">{time || '--:--'}</span>
          {location && (
            <div className="flex items-center gap-1 text-[10px] font-bold opacity-60 border-l border-current/20 pl-3">
              <MapPin className="w-3 h-3" />
              <span className="truncate max-w-[80px]">{location}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
